// extracted by mini-css-extract-plugin
export default {"input":"Paa-z","button":"Qaa-z","selected":"Raa-z","unavailable":"Saa-z","oos":"Taa-z","image":"Uaa-z","paperCutDisabledOverlay":"Vaa-z"};